module.exports = __webpack_public_path__ + "aa6ff19529d3e41505c677e2cd3d8fdd.svg";